import { render, staticRenderFns } from "./DpaFileForm.vue?vue&type=template&id=6b083db2&"
import script from "./DpaFileForm.vue?vue&type=script&lang=js&"
export * from "./DpaFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports